<template>
  <div class="course_introduce">
    <div class="mt-20" v-if="courseSettingInfo.schoolTimetable && (courseSettingInfo.schoolTimetableEnabled != 0)" v-html="courseSettingInfo.schoolTimetable"></div>
    <div v-else>
        <moe-empty url="moe_empty_bg_img.png" emptyText="暂无课程课表"></moe-empty>
      </div>
  </div>
</template>

<script>
export default {
  name: 'GjkcH5TimeTable',
  props:{
    courseSettingInfo:{}
  },

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>